import React, { useState, useRef, useEffect } from 'react';
import {
  Grid,
  Typography,
  Card,
  CardActionArea,
  CardContent,
  Box,
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton
} from "@mui/material";
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import AlarmOnIcon from '@mui/icons-material/AlarmOn';
import DirectionsBusIcon from '@mui/icons-material/DirectionsBus';
import CloseIcon from '@mui/icons-material/Close';
import ZoomInIcon from '@mui/icons-material/ZoomIn';
import ZoomOutIcon from '@mui/icons-material/ZoomOut';
import { useNavigate } from 'react-router-dom';
import { Document, Page, pdfjs } from 'react-pdf';
import { RegisterUsabilityLog } from '../../../shared/data-services/ModuleUsabilityLog-service';
import { CallMissedOutgoing } from '@mui/icons-material';

pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.js`;

const TRANSPORT_BENEFIT_BASES = ['ADZ', 'AXM', 'BAQ', 'CLO', 'CTG', 'MDE', 'PEI', 'SMR'];
const PDF_REGIONALES = './Documents/POLITICA%20DE%20TRANSPORTE%20BASES%20REGIONALES.pdf';

const ContentLasa = ({ user }) => {
  const name = user.name;
  const navigate = useNavigate();
  const [pdfModalOpen, setPdfModalOpen] = useState(false);
  const [numPages, setNumPages] = useState(null);
  const [pdfScale, setPdfScale] = useState(1.0);
  const containerRef = useRef(null);
  const [containerWidth, setContainerWidth] = useState(Math.min(window.innerWidth - 64, 700));

  const showTransportBenefit = user.airport ? TRANSPORT_BENEFIT_BASES.includes(user.airport.code) : false;

  useEffect(() => {
    if (!pdfModalOpen) return;
    const updateWidth = () => {
      if (containerRef.current) {
        setContainerWidth(containerRef.current.clientWidth - 16);
      }
    };
    const timer = setTimeout(updateWidth, 50);
    window.addEventListener('resize', updateWidth);
    return () => {
      clearTimeout(timer);
      window.removeEventListener('resize', updateWidth);
    };
  }, [pdfModalOpen]);

  const handleCloseModal = () => {
    setPdfModalOpen(false);
    setNumPages(null);
    setPdfScale(1.0);
  };

  const handleQuickAccess = async (route, logText) => {
    await RegisterUsabilityLog(logText, user.employeeId);
    navigate(route);
  };

return (
  <Box sx={{ width: '100%', overflowX: 'hidden', m: 0, p: 0 }}>
  <Grid container spacing={2} sx={{ overflowX: 'hidden', maxWidth: '100%', margin: 0 }}>
    <Grid item xs={12} md={7}>
      <Grid container spacing={1}>

        {/* Texto de bienvenida */}
        <Grid item xs={12}>
          <Typography variant="h5" style={{ color: '#8ebb37' }} fontWeight="bold" sx={{ m: 1 }}>
            <b>¡Hola {name}!</b>
          </Typography>
          <Typography variant="h5" style={{ color: '#1a3072' }} fontWeight="bold" sx={{ m: 1 }}>
            <i>Bienvenido a la plataforma Tu Experiencia <span style={{ color: '#00b0ef' }}><b>Talma</b></span></i>
          </Typography>
        </Grid>

        {/* Video */}
        <Grid item xs={12} style={{ marginBottom: 20 }}>
          <iframe
            width="100%"
            height="415"
            src="https://www.youtube.com/embed/kiJ4ozGEDcc"
            title="YouTube video player"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            allowFullScreen
          ></iframe>
        </Grid>

        <Grid item xs={12}>
          <Grid container spacing={2} justifyContent="center" sx={{ mt: 2 }}>
            {/* Botón: Mis Turnos */}
              <Grid item xs={12} sm={4} md={3}>
              <Card sx={{ maxWidth: 200, mx: "auto", backgroundColor: "#00000008" }}>
                <CardActionArea
                  onClick={() => handleQuickAccess('/ShiftCalendar', 'Mis Turnos - Autogestión')}
                  sx={{ textAlign: "center", height: "100%", display: "flex", flexDirection: "column", justifyContent: "center" }}
                >
                  <CalendarMonthIcon sx={{ fontSize: 60, color: "#27b9d4", mt: 2 }} />
                  <CardContent sx={{ p: 0, minHeight: 80 }}>
                    <Typography variant="h6" sx={{ color: "#8ebb37", fontWeight: "bold", textAlign: 'center' }}>
                      Consulta de
                    </Typography>
                    <Typography variant="h6" sx={{ color: "#1a3072", fontWeight: "bold", textAlign: 'center' }}>
                      Mis Turnos
                    </Typography>
                  </CardContent>
                </CardActionArea>
              </Card>
            </Grid>

            {/* Botón: Mis Marcaciones */}
              <Grid item xs={12} sm={4} md={3}>
              <Card sx={{ maxWidth: 200, mx: "auto", backgroundColor: "#00000008" }}>
                <CardActionArea
                  onClick={() => handleQuickAccess('/EmployeeWorkShif', 'Mis Marcaciones - Autogestión')}
                  sx={{ textAlign: "center", height: "100%", display: "flex", flexDirection: "column", justifyContent: "center" }}
                >
                  <AlarmOnIcon sx={{ fontSize: 60, color: "#27b9d4", mt: 2 }} />
                  <CardContent sx={{ p: 0, minHeight: 80 }}>
                    <Typography variant="h6" sx={{ color: "#8ebb37", fontWeight: "bold", textAlign: 'center' }}>
                      Consulta de
                    </Typography>
                    <Typography variant="h6" sx={{ color: "#1a3072", fontWeight: "bold", textAlign: 'center' }}>
                      Mis Marcaciones
                    </Typography>
                  </CardContent>
                </CardActionArea>
              </Card>
            </Grid>

            {/* Botón: Permisos y Ausencias */}
              <Grid item xs={12} sm={4} md={3}>
              <Card sx={{ maxWidth: 250, mx: "auto", backgroundColor: "#00000008" }}>
                <CardActionArea
                  onClick={() => handleQuickAccess('/EmployeeAbsencePermissions', 'Solicitud Permisos y Ausencias - Autogestión')}
                  sx={{ textAlign: "center" }}
                >
                  <CallMissedOutgoing sx={{ fontSize: 60, color: "#27b9d4" }} />
                  <CardContent sx={{ p: 0 }}>
                    <Typography variant="h6" sx={{ color: "#8ebb37", fontWeight: "bold", m: 0 }}>
                      Solicitud
                    </Typography>
                    <Typography variant="h6" sx={{ color: "#1a3072", fontWeight: "bold" }}>
                      Permisos y Ausencias
                    </Typography>
                  </CardContent>
                </CardActionArea>
              </Card>
            </Grid>

            {/* Botón: Política de Beneficio de Transporte (solo bases habilitadas) */}
            {showTransportBenefit && (
              <Grid item xs={12} sm={4} md={3}>
                <Card sx={{ maxWidth: 250, mx: "auto", backgroundColor: "#00000008" }}>
                  <CardActionArea
                    onClick={() => setPdfModalOpen(true)}
                    sx={{ textAlign: "center", height: "100%", display: "flex", flexDirection: "column", justifyContent: "center" }}
                  >
                    <DirectionsBusIcon sx={{ fontSize: 60, color: "#27b9d4", mt: 2 }} />
                    <CardContent sx={{ p: 0, minHeight: 80 }}>
                      <Typography variant="h6" sx={{ color: "#8ebb37", fontWeight: "bold", textAlign: 'center' }}>
                        Política de
                      </Typography>
                      <Typography variant="h6" sx={{ color: "#1a3072", fontWeight: "bold", textAlign: 'center' }}>
                        Beneficio de Transporte
                      </Typography>
                    </CardContent>
                  </CardActionArea>
                </Card>
              </Grid>
            )}
          </Grid>
        </Grid>

        {/* Modal PDF: Política de Beneficio de Transporte */}
        <Dialog
          open={pdfModalOpen}
          onClose={handleCloseModal}
          fullWidth
          maxWidth="md"
        >
          <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', color: '#1a3072', fontWeight: 'bold', pb: 0 }}>
            Política de Beneficio de Transporte
            <IconButton onClick={handleCloseModal} size="small">
              <CloseIcon />
            </IconButton>
          </DialogTitle>
          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 1, py: 1, borderBottom: '1px solid #e0e0e0' }}>
            <IconButton size="small" onClick={() => setPdfScale(s => Math.max(0.5, +(s - 0.25).toFixed(2)))} disabled={pdfScale <= 0.5}>
              <ZoomOutIcon />
            </IconButton>
            <Typography variant="body2" sx={{ minWidth: 45, textAlign: 'center', color: '#1a3072', fontWeight: 'bold' }}>
              {Math.round(pdfScale * 100)}%
            </Typography>
            <IconButton size="small" onClick={() => setPdfScale(s => Math.min(3.0, +(s + 0.25).toFixed(2)))} disabled={pdfScale >= 3.0}>
              <ZoomInIcon />
            </IconButton>
          </Box>
          <DialogContent sx={{ p: 1, overflowY: 'auto' }} ref={containerRef}>
            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', userSelect: 'none' }}>
              <Document
                file={PDF_REGIONALES}
                onLoadSuccess={({ numPages }) => setNumPages(numPages)}
              >
                {Array.from(new Array(numPages), (el, index) => (
                  <Box key={`page_${index + 1}`} sx={{ mb: 1 }}>
                    <Page
                      pageNumber={index + 1}
                      width={containerWidth * pdfScale}
                      renderTextLayer={false}
                      renderAnnotationLayer={false}
                    />
                  </Box>
                ))}
              </Document>
            </Box>
          </DialogContent>
        </Dialog>
      </Grid>
    </Grid>


    <Grid item xs={12} md={5}>
          <img
        src="./Images/Home_TuExperiencia.jpg"
        alt="logo"
        style={{
          width: '100%',
          maxWidth: '100%',
          height: 'auto',
          objectFit: 'contain',
          display: 'block'
        }}
      />
    </Grid>
  </Grid>
  </Box>
);

}

export default ContentLasa;
